import { render, staticRenderFns } from "./FinalDeterminationDialog.vue?vue&type=template&id=0324635c&scoped=true"
import script from "./FinalDeterminationDialog.vue?vue&type=script&lang=js"
export * from "./FinalDeterminationDialog.vue?vue&type=script&lang=js"
import style0 from "./FinalDeterminationDialog.vue?vue&type=style&index=0&id=0324635c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324635c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0324635c')) {
      api.createRecord('0324635c', component.options)
    } else {
      api.reload('0324635c', component.options)
    }
    module.hot.accept("./FinalDeterminationDialog.vue?vue&type=template&id=0324635c&scoped=true", function () {
      api.rerender('0324635c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fixDutyFine/DeductionConfirmationForm/component/FinalDeterminationDialog.vue"
export default component.exports